import * as React from 'react';
import ReactDOM from 'react-dom';
import S from './ModalBackdrop.styles';
const ModalBackdrop = (props) => {
    return ReactDOM.createPortal(React.createElement(S.Container, { className: props.className, onClick: props.onClick, "aria-hidden": true }), document.body);
};
export default ModalBackdrop;
